import cn from 'bem-cn';

import { Icon, Stack } from '../../UI';

import './AchievementModal.scss';
import { PHANTOMAS_ACHIEVEMENT_IMAGE } from '../../../constants';

import { AchievementModalProps } from './AchievementModal.types';

const b = cn('achievement-modal');

export const AchievementModalError = (props: Partial<AchievementModalProps>) => {
    const { onClose } = props;

    return (
        <Stack className={b()}>
            <div className={b('header')}>
                <Stack className={b('header-button')}>
                    <Icon name="share" size={48} aria-label="Поделиться" disabled />
                </Stack>
                <Stack className={b('header-button')}>
                    <Icon name="close" size={48} aria-label="Закрыть" onClick={onClose} />
                </Stack>
            </div>
            <Stack spacing={8} className={b('content')}>
                <img className={b('image')} src={PHANTOMAS_ACHIEVEMENT_IMAGE} alt="" />
                <h2>Произошла ошибка при получении брелка</h2>
            </Stack>
            <div className={b('separator')} />
            <Stack spacing={8} className={b('footer')}>
                {' '}
            </Stack>
        </Stack>
    );
};
